/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiValidationStatus
 */
export interface InternalApiValidationStatus {
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiValidationStatus
     */
    isValid: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalApiValidationStatus
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the InternalApiValidationStatus interface.
 */
export function instanceOfInternalApiValidationStatus(value: object): value is InternalApiValidationStatus {
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    return true;
}

export function InternalApiValidationStatusFromJSON(json: any): InternalApiValidationStatus {
    return InternalApiValidationStatusFromJSONTyped(json, false);
}

export function InternalApiValidationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiValidationStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'isValid': json['isValid'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function InternalApiValidationStatusToJSON(json: any): InternalApiValidationStatus {
    return InternalApiValidationStatusToJSONTyped(json, false);
}

export function InternalApiValidationStatusToJSONTyped(value?: InternalApiValidationStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isValid': value['isValid'],
        'errorMessage': value['errorMessage'],
    };
}

